module.exports = __webpack_public_path__ + "static/media/imagem8.1b0567e5.jpeg";